module.exports = __webpack_public_path__ + "assets/fonts/opensans-italic-webfont.woff";